<dialog-draggable-header>Add Part Change</dialog-draggable-header>

<mat-dialog-content>
  <form [formGroup]="modifyPartChangeForm" class="modify-parts-change-form">
    <div>
      <mat-form-field>
        <mat-label>Affects Design:</mat-label>
        <mat-select (valueChange)="affectsDesignChanged($event)" formControlName="affectsDesign">
          <mat-option [value]="true">Yes</mat-option>
          <mat-option [value]="false">No</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-checkbox [disabled]="true" formControlName="designDetail">Detail</mat-checkbox>
      <mat-checkbox [disabled]="!this.modifyPartChangeForm.get('affectsDesign').value" formControlName="designAsm">
        Asm
      </mat-checkbox>
      <mat-checkbox [disabled]="!this.modifyPartChangeForm.get('affectsDesign').value" formControlName="designItac">
        ITAC
      </mat-checkbox>
      <mat-checkbox [disabled]="true" formControlName="designEtac">ETAC</mat-checkbox>
      <mat-checkbox [disabled]="!this.modifyPartChangeForm.get('affectsDesign').value" formControlName="designHaf">
        HandApply Fixt
      </mat-checkbox>
    </div>
    <div>
      <mat-form-field>
        <mat-label>Affects GD&T:</mat-label>
        <mat-select (valueChange)="affectsGdtChanged($event)" formControlName="affectsGdt">
          <mat-option [value]="true">Yes</mat-option>
          <mat-option [value]="false">No</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-checkbox [disabled]="true" formControlName="gdtDetail">Detail</mat-checkbox>
      <mat-checkbox [disabled]="!this.modifyPartChangeForm.get('affectsGdt').value" formControlName="gdtAsm">
        Asm
      </mat-checkbox>
      <mat-checkbox [disabled]="!this.modifyPartChangeForm.get('affectsGdt').value" formControlName="gdtItac">
        ITAC
      </mat-checkbox>
      <mat-checkbox [disabled]="true" formControlName="gdtEtac">ETAC</mat-checkbox>
      <mat-checkbox [disabled]="!this.modifyPartChangeForm.get('affectsGdt').value" formControlName="gdtHaf">
        Hand Apply Fixt
      </mat-checkbox>
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions>
  <button  color="primary" (keypress.enter)="save()" (click)="save()">Update</button>
  <button mat-raised-button (keypress.enter)="close()" (click)="close()">Cancel</button>
</mat-dialog-actions>